import React from 'react';
import { SectionSubtitleWrapper } from './SectionSubtitle.styles';

const SectionSubtitle = ({ children, ...restProps }) => {
  return <SectionSubtitleWrapper {...restProps}>{children}</SectionSubtitleWrapper>; // eslint-disable-line
};

export default SectionSubtitle;
